import { nodeFromHtml } from '@/utility/functions';

const Modal = function(html) {
  const detectModalClick = (event) => {
    if(
      !event.target.hasAttribute('data-modal-trigger-close') ||
      null !== event.target.closest('data-modal-body')
    ) {
      return;
    }

    this.destroy();
  };

  const detectModalEscape = (event) => {
      if(event.keyCode !== 27) { // escape
        return;
      }

      this.destroy();
  };

  this.destroy = () => {
    modalEl.parentNode.removeChild(modalEl);

    document.removeEventListener('click', detectModalClick);
    document.removeEventListener('keydown', detectModalEscape);

    modalEl = null;
  };

  let modalEl = nodeFromHtml(html);

  document.getElementById('assistive-portal').appendChild(modalEl);
  document.addEventListener('click', detectModalClick);
  document.addEventListener('keydown', detectModalEscape);

  return this;
};

export default Modal;
